import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
// Importe todos os seus arquivos de tradução
import translationES from '../i18n/es/global.json';
import translationPT from '../i18n/pt/global.json';
import translationEN from '../i18n/en/global.json';
import translationFR from '../i18n/fr/global.json';
import translationIT from '../i18n/it/global.json';
import translationDE from '../i18n/de/global.json';
import translationCH from '../i18n/zhCH/global.json';

const resources = {
  es: { translation: translationES },
  pt: { translation: translationPT },
  en: { translation: translationEN },
  fr: { translation: translationFR },
  it: { translation: translationIT },
  de: { translation: translationDE },
  zh: { translation: translationCH },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    // Define o idioma inicial manualmente, lendo do localStorage
    lng: localStorage.getItem('i18nextLng') || 'es',
    fallbackLng: 'es',
    detection: {
      // Remove a verificação automática de cache para evitar conflitos
      // Apenas diz ao i18next para ler o idioma do localStorage se necessário
      order: ['localStorage', 'cookie', 'navigator'],
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;